<template>
  <va-create-layout>
    <point-form :title="title" :item="item"></point-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
